import React from "react";
import AssetRelianceContentReport from "./AssetRelianceContentReport";
import {FveDiscountRateType} from "../../../ClientManagement/AssetReliance/AssetRelianceButtonState";

interface AssetRelianceWrapperProps {
    displayName: string,
    id: string,
    showExpectedExcessAsset?: boolean,
    includeLifeInsuranceAtDeath?: boolean,
    selectedFveDiscountRate?: FveDiscountRateType
}


const AssetRelianceWrapper = ({displayName, id, showExpectedExcessAsset = false,
                                  includeLifeInsuranceAtDeath = false,
                                  selectedFveDiscountRate = FveDiscountRateType.TRIPLE_NET}: AssetRelianceWrapperProps) => {

    return (<>
            <div className="asset-reliance">
                <AssetRelianceContentReport
                    id={id}
                    displayName={displayName}
                    showExpectedExcessAsset={showExpectedExcessAsset}
                    includeLifeInsuranceAtDeath={includeLifeInsuranceAtDeath}
                    selectedFveDiscountRate={selectedFveDiscountRate}
                />
            </div>
        </>
    )
}

type assetRelianceContainerProps = {
    displayName: string,
    profileId: string,
    showExpectedExcessAsset?: boolean,
    includeLifeInsuranceAtDeath?: boolean,
    selectedFveDiscountRate?: FveDiscountRateType
}

const AssetRelianceContainer = ({displayName,showExpectedExcessAsset = false,
                                    includeLifeInsuranceAtDeath = false,
                                    selectedFveDiscountRate = FveDiscountRateType.TRIPLE_NET,profileId}: assetRelianceContainerProps) => {

    return <AssetRelianceWrapper displayName={displayName}
                                 id={profileId}
                                 showExpectedExcessAsset={showExpectedExcessAsset}
                                 includeLifeInsuranceAtDeath={includeLifeInsuranceAtDeath}
                                 selectedFveDiscountRate={selectedFveDiscountRate}
    />
}

export default AssetRelianceContainer;